import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';

// Renders a static legal HTML document (from /public/legal) verbatim, including its own <style>
export const LegalPage = ({ slug, title }) => {
  const [html, setHtml] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = `${title} — DesignSync Agent`;
    fetch(`/legal/${slug}.html`)
      .then((res) => (res.ok ? res.text() : Promise.reject(new Error(`HTTP ${res.status}`))))
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const styles = Array.from(doc.head.querySelectorAll('style')).map((s) => s.outerHTML).join('');
        setHtml(DOMPurify.sanitize(styles + doc.body.innerHTML, { ADD_TAGS: ['style'], ADD_ATTR: ['target'], FORCE_BODY: true }));
      })
      .catch((err) => setError(err.message));
  }, [slug, title]);

  if (error) return <p style={{ padding: 32 }} data-testid="legal-page-error">Unable to load {title}: {error}</p>;
  return <div className="legal-page" data-testid={`legal-page-${slug}`} dangerouslySetInnerHTML={{ __html: html }} />;
};

export default LegalPage;
